import React, {PureComponent, Suspense} from 'react'
import PropTypes from 'prop-types'
import {AddIcon, EditIcon, RemoveIcon} from 'rambler-ui'
import {retry} from '@rambler-id/promise'
import redirect from 'utils/redirect'
import {CHANGE_PHONE} from 'utils/urls'
import maskPhoneNumber from 'utils/maskPhoneNumber'
import InternalHeader from 'components/InternalHeader'
import ProfileSection from 'components/ProfileSection'
import ProfileItem from 'components/ProfileItem'
import RowButton from 'components/RowButton'
import PhoneIcon from 'components/icons/PhoneIcon'
import AddPhoneOffer from '../AddPhoneOffer'
import DeleteContact from '../DeleteContact'
import styles from './styles.css'
import {SuspenseFallback} from 'components/SuspenseFallback'
import SberbankIcon from 'components/icons/SberbankIcon'

const AddContactPhone = React.lazy(
  retry(
    () =>
      import(
        /* webpackChunkName: "add-contact-phone" */ 'containers/AddContactPhone'
      )
  )
)

export default class Phones extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    info: PropTypes.object,
    phones: PropTypes.array,
    contactPhones: PropTypes.array,
    editable: PropTypes.string,
    setEditable: PropTypes.func.isRequired,
    openPopup: PropTypes.func.isRequired,
    deleteContact: PropTypes.func.isRequired
  }

  get sberbankPhone() {
    const sberSocialProfile = this.props.socialProfiles.find(
      ({provider}) => provider === 'sberbank'
    )

    return sberSocialProfile && sberSocialProfile.phone
  }

  deleteContact = async (contact) => {
    const {openPopup, deleteContact} = this.props

    try {
      await openPopup((onResolve, onReject) => (
        <DeleteContact
          contact={maskPhoneNumber(contact)}
          onResolve={onResolve}
          onReject={onReject}
          cerberId={(target) => `${target}delete_phone::delete_phone_button`}
        />
      )).closed

      deleteContact(contact)
    } catch (error) {} // eslint-disable-line no-empty
  }

  suggestAddPhone = async (field) => {
    const {type, info, openPopup, setEditable} = this.props

    if (type !== 'general' || info.ramblerMailPhone) {
      setEditable(field)

      return
    }

    try {
      await openPopup((onResolve, onReject) => (
        <AddPhoneOffer onResolve={onResolve} onReject={onReject} />
      )).closed

      redirect(CHANGE_PHONE)
    } catch (error) {}
  }

  render() {
    const {type, info, phones, contactPhones, editable, setEditable} =
      this.props

    return (
      <ProfileSection section="phones" color="#cddc39" icon={<PhoneIcon />}>
        <InternalHeader>
          <h2>Телефонные номера</h2>
          <p>
            Здесь перечислены все телефонные номера, которые вы указывали при
            использовании сервисов Rambler&Co.
            {type === 'general' &&
              `
              Номер для восстановления доступа к Рамблер/почте в целях безопасности удалить нельзя,
              но его можно заменить на другой номер.
            `}{' '}
            Вы можете добавить любое количество телефонных номеров для связи с
            вами.
          </p>
        </InternalHeader>
        {this.sberbankPhone && (
          <ProfileItem muted>
            <div className={styles.row}>
              {maskPhoneNumber(this.sberbankPhone)}
              <SberbankIcon className={styles.sberIcon} />
            </div>
          </ProfileItem>
        )}
        {info.ramblerMailPhone && (
          <ProfileItem
            rightIcon={
              <RowButton
                label="Изменить номер телефона"
                onClick={() => redirect(CHANGE_PHONE)}
                data-cerber-id="profile::phone_number::change_phone">
                <EditIcon />
              </RowButton>
            }>
            <div>
              <span>{info.ramblerMailPhone}</span>
              <small className={styles.note}>
                Номер для восстановления доступа
              </small>
            </div>
          </ProfileItem>
        )}
        {phones.map(({accountId}) => (
          <ProfileItem key={accountId}>
            {maskPhoneNumber(accountId)}
          </ProfileItem>
        ))}
        {contactPhones.map(({contact}) =>
          contact === this.sberbankPhone ? null : (
            <ProfileItem
              key={contact}
              rightIcon={
                <RowButton
                  label="Удалить телефонный номер"
                  data-cerber-id="profile::phone_number::delete_phone"
                  onClick={() => this.deleteContact(contact)}>
                  <RemoveIcon />
                </RowButton>
              }>
              {maskPhoneNumber(contact)}
            </ProfileItem>
          )
        )}
        {editable === 'contactPhone' ? (
          <Suspense
            fallback={
              <SuspenseFallback withoutBorder={!info.ramblerMailPhone} />
            }>
            <AddContactPhone onClose={() => setEditable(null)} />
          </Suspense>
        ) : (
          <ProfileItem
            rightIcon={
              <RowButton
                label="Добавить телефонный номер"
                onClick={() => this.suggestAddPhone('contactPhone')}>
                <AddIcon />
              </RowButton>
            }
            cerberId="profile::phone_number::add_phone">
            <button
              type="button"
              data-anchor
              tabIndex="0"
              onClick={() => this.suggestAddPhone('contactPhone')}>
              Добавить телефонный номер
            </button>
          </ProfileItem>
        )}
      </ProfileSection>
    )
  }
}
